import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-paper px-5 py-12 sm:py-20" data-id="element-71" data-mp="1hbgu4bwv3v38">
      <div className="mx-auto max-w-2xl" data-id="element-72" data-mp="1cfjfqb55syt3">
        <h2 className="text-center font-serif-display text-2xl font-bold text-ink sm:text-4xl" data-id="element-73" data-mp="1ccncq8egfjxs">
          Frequently asked questions
        </h2>

        <div className="mt-8 divide-y divide-cobalt/20 border-y border-cobalt/20" data-id="element-74" data-mp="25473cddds09t">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-75" data-mp="1v5hkoidnubsi" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex min-h-[48px] w-full items-center justify-between gap-4 py-4 text-left" data-id="element-76" data-mp="1v4g643xfr761">
                  <span className="text-sm font-semibold text-ink sm:text-base" data-id="element-77" data-mp="1korrtgyfbuhi">{faq.question}</span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-78" data-mp="1pli9u9tsh05k">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-79" data-mp="1fodlq4gduum4" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="11xijhb0e3bri" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-81" data-mp="16pieqq5ilghr">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-82" data-mp="s0431begumz7">
                      <p className="pb-4 text-sm leading-relaxed text-ink/70" data-id="element-83" data-mp="2pmn39s4xdny1">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}